import { render, staticRenderFns } from "./case2.vue?vue&type=template&id=09d7fcb4&scoped=true&"
import script from "./case2.vue?vue&type=script&lang=js&"
export * from "./case2.vue?vue&type=script&lang=js&"
import style0 from "./case2.vue?vue&type=style&index=0&id=09d7fcb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d7fcb4",
  null
  
)

export default component.exports